module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ulica")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "placeholder": "Ime",
      "type": "text",
      "name": "preTime"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCity),
      expression: "newCity"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "placeholder": "Grad",
      "type": "text",
      "name": "preTime"
    },
    domProps: {
      "value": (_vm.newCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Region")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedNeighborhood),
      expression: "selectedNeighborhood"
    }],
    staticClass: "form-control border-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedNeighborhood = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.regions), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": _vm.buttonName,
      "value": _vm.buttonName
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e28742e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/EditAddressModal.vue
// module id = 471
// module chunks = 1